// src/components/OCDDissolver/quotes.js
export const motivationalQuotes = [
  "Every moment of awareness is a victory.",
  "Freedom comes when you observe, not react.",
  "You are not your thoughts; you are the observer.",
  "Let go and let clarity flow through you.",
  "Calm awareness dissolves the old patterns.",
  "Each breath anchors you in the present.",
  "Observation without judgment brings peace.",
  "You are the sky; thoughts are just passing clouds.",
  "Release the urge; embrace the pause.",
  "Your inner stillness is more powerful than the compulsion.",
  "Awareness is the key to liberation.",
  "Thoughts come and go; your essence remains.",
  "Patience with yourself creates freedom.",
  "The moment you notice, you are free.",
  "Trust the process of letting go.",
  "Inner clarity arises when you pause.",
  "You are bigger than any habit.",
  "Notice, breathe, release.",
  "Compulsions fade when you witness them.",
  "Your consciousness is stronger than repetition.",
  "Observe without attachment.",
  "Surrender to awareness, not action.",
  "Peace arises when you stop struggling.",
  "The mind relaxes when you accept the present.",
  "Every pause strengthens your inner control.",
  "You are a calm witness to your thoughts.",
  "The urge is temporary; awareness is permanent.",
  "Gentle observation dissolves compulsion.",
  "You are free before the thought even arises.",
  "Presence overpowers repetition.",
  "Breathe deeply and let go.",
  "Let awareness guide you, not fear.",
  "You are the stillness behind the action.",
  "Detach and observe — this is power.",
  "Your mind learns calm through gentle noticing.",
  "The observer within is always untouched.",
  "Every mindful pause weakens the pattern.",
  "Notice the urge without reacting.",
  "Freedom is already within you.",
  "Observe the thought, don’t follow it.",
  "The present moment is your anchor.",
  "Gentle attention dissolves inner tension.",
  "Your inner self is bigger than any ritual.",
  "Awareness is your natural state.",
  "Release tension through conscious breathing.",
  "Calm clarity arises naturally.",
  "You are not your compulsion.",
  "Each breath brings more presence.",
  "Let go and feel your true self.",
  "Compulsions are optional; awareness is your choice.",
];
